import { render, staticRenderFns } from "./CourseCardsVirtual.vue?vue&type=template&id=f587ea40&scoped=true&"
import script from "./CourseCardsVirtual.vue?vue&type=script&lang=js&"
export * from "./CourseCardsVirtual.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardsVirtual.vue?vue&type=style&index=0&id=f587ea40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f587ea40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCourseCard: require('/opt/build/repo/components/Cards/CourseCard.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
